module.exports = __webpack_public_path__ + "src/assets/img/door_right_back.a7ee2e75.svg";